export interface LayerExtractResponseModel {
  message: string;
  downloadId: string;
}
